import { Divider, Grid } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import { Typography } from '@HomaHealth/ui-component-library';
import { patientAccessTheme } from '@HomaHealth/ui-component-library/lib/theme/theme';
import {
  Breadcrumbs,
  Checklist,
  HealthProfileAccordion,
  PatientProfileAccordion,
} from '@HomaHealth/ui-component-library/lib/_AIQ-components';
import React from 'react';
import componentConstants from '../../../core-utils/messages/componentConstants';
import { useStores } from '../../../stores';

export interface PatientProfileAccordionData {
  values: string[];
  hospitalVisitData: any;
  totalCostData: any;
  recentVisitData: any;
  memberRelationShipData: any;
  enrollmentData: any;
}

export interface HealthProfileAccordionData {
  currentCondition: string;
  latentRiskData: any;
}

export interface PatientDetailsSideContentProps {
  memberId: string;
  patientProfileAccordionData: PatientProfileAccordionData;
  healthProfileAccordionData: HealthProfileAccordionData;
  showContact?: boolean;
  patientState: [any, React.Dispatch<React.SetStateAction<any>>];
   
  handleContactChange?: () => void;
}

const PatientDetailsSideContent: React.FC<PatientDetailsSideContentProps> = ({
  memberId,
  patientProfileAccordionData,
  healthProfileAccordionData,
  showContact,
  patientState,
  handleContactChange,
}) => {
  const useStyles = makeStyles()({
    patientProfileAccordion: {
      '& >.MuiAccordion-root:before': {
        height: '0px',
      },
    },
  });

  const { classes } = useStyles();

  const organismConstants =
    componentConstants.ORGANISMS.PATIENT_DETAILS_SIDE_CONTENT;
  const memberSummaryStore = useStores().memberSummaryStore;

  const getPath = () => {
    const breadcrumbPath = memberSummaryStore.pathDetails;
    breadcrumbPath[breadcrumbPath.length - 1][2].color =
      patientAccessTheme.palette.primary[500];
    breadcrumbPath[breadcrumbPath.length - 1][2].fontWeight = 500;
    breadcrumbPath[breadcrumbPath.length - 1].push(() => {
      breadcrumbPath[breadcrumbPath.length - 1][2].color =
        patientAccessTheme.palette.text.highemphasis;
      breadcrumbPath[breadcrumbPath.length - 1][2].fontWeight = 600;
      breadcrumbPath[breadcrumbPath.length - 1][3] = null;
      history.back();
    });
    return breadcrumbPath;
  };

  const breadcrumbItemList = [
    ['icon', <Checklist height={'24px'} width={'24px'} />],
    ...getPath(),
    [
      'text',
      memberId,
      {
        color: patientAccessTheme.palette.text.highemphasis,
        width: '75px',
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        direction: 'rtl',
      },
    ],
  ];

  return (
    <div>
      <Grid container>
        <Grid style={{ margin: '38px 18px 0px 16px' }}>
          <Breadcrumbs itemList={breadcrumbItemList} />
        </Grid>
        <Grid
          container
          style={{ margin: '16px 24px' }}
          sx={{
            alignItems: 'center',
          }}
        >
          <Typography
            fontSize="14px"
            textColor={patientAccessTheme.palette.text.mediumemphasis}
            lineHeight="25px"
          >
            {organismConstants.MEMBER_ID}
          </Typography>
          <Typography
            fontSize="14px"
            fontType="medium"
            textColor={patientAccessTheme.palette.text.highemphasis}
            lineHeight="18px"
            margin="0px 0px 0px 4px"
          >
            {memberId}
          </Typography>
        </Grid>
      </Grid>
      <Divider style={{ margin: '0px 0px 10px 0px' }} />
      <div className={classes.patientProfileAccordion}>
        <PatientProfileAccordion
          {...patientProfileAccordionData}
          showContact={showContact}
          patientState={patientState}
          handleContactChange={handleContactChange}
        />
      </div>
      <div>
        <HealthProfileAccordion {...healthProfileAccordionData} />
      </div>
    </div>
  );
};

export default PatientDetailsSideContent;
